import React from 'react'

import { Box, Checkbox, Tag, Text } from '@factorialco/deprecated-design-system'
import { WorkSpaceSlotFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type { WorkSpaceSlotNode } from 'modules/space_control/hooks/useWorkSpaceSlots'

interface Props {
  slots: WorkSpaceSlotNode[]
  onChange: (value: number) => void
  selectedValues: number[]
  isHalfDay?: boolean
}

const BookingSlots = ({ slots, onChange, selectedValues, isHalfDay = false }: Props) => {
  const getLabel = (index: number, isHalfDay: boolean, slot: WorkSpaceSlotNode) => {
    if (isHalfDay) {
      return index === 0
        ? i18n.t('space_control.overview.booking_sidepanel.time_slots.first_half')
        : i18n.t('space_control.overview.booking_sidepanel.time_slots.second_half')
    } else {
      return `${slot.startsAt} - ${slot.endsAt}`
    }
  }
  const isBooked = ({ slot }: { slot: WorkSpaceSlotFragment }) => {
    if (slot.currentCapacity === 0) {
      return true
    }
    return false
  }
  return (
    <Box gap="s4">
      <Text.Normal size="200" weight="medium" color="grey1000">
        {i18n.t('space_control.overview.booking_sidepanel.time_slots.label')}
      </Text.Normal>
      <Box
        borderRadius={{ all: 'abs008' }}
        border={{
          all: {
            color: 'grey400',
            width: 's1',
            style: 'solid',
          },
        }}
        gapDivider
      >
        {slots.map((slot, i) => (
          <Box
            key={i}
            flexDirection="row"
            gap="s8"
            alignItems="center"
            justifyContent="spaceBetween"
            padding="s16"
            background={isBooked({ slot: slot }) ? 'grey100' : undefined}
          >
            <Checkbox
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                onChange(Number(event.target.value))
              }
              value={slot.slotNumber}
              checked={selectedValues.includes(slot.slotNumber)}
              disabled={isBooked({ slot: slot })}
              label={getLabel(i, isHalfDay, slot)}
            />
            {isBooked({ slot: slot }) && (
              <Tag type="grey">
                {i18n.t('space_control.overview.booking_sidepanel.time_slots.is_booked')}
              </Tag>
            )}
          </Box>
        ))}
      </Box>
    </Box>
  )
}

export default observer(BookingSlots)
